import apiService from "./api";

const outageService = {
  getActiveOutage(lang) {
    return apiService.get("/outage/active", { lang });
  },
  getOutages(lang) {
    return apiService.get("/outage", { lang });
  },
  createOutage(payload) {
    return apiService.post("/outage", payload);
  },
  activateOutage(id) {
    return apiService.patch(`/outage/${id}/activate`);
  },
  deactivateAllOutages() {
    return apiService.post("/outage/deactivate-all");
  },
  deleteOutage(id) {
    return apiService.delete(`/outage/${id}`);
  },
};

export default outageService;
